import React, { useState } from 'react';
import { RouteComponentProps } from 'react-router';
import { Form, Button, Checkbox } from 'components';
import { ReadFilled } from '@ant-design/icons';

import {
  CardAvatar,
  CardHeader,
  CardProgress,
  VerticalSpace,
} from '@brokerbay/design-components';

export type ReviewTOSViewProps = RouteComponentProps<{ hash?: string }> & {
  handleGoBackStep: () => void;
  handleGoNextStep?: () => void;
  handleSubmit: () => Promise<string | void>;
};

export const ReviewTOSView = ({
  handleGoBackStep,
  handleGoNextStep,
  handleSubmit,
}: ReviewTOSViewProps) => {
  const [loading, setLoading] = useState<boolean>(false);

  // TODO: handle the terms of service by submitting to an update profile endpoint and then on success redirecting to the app.
  const onSubmit = async () => {
    setLoading(true);
    try {
      await handleSubmit();
      setLoading(false);
      if (handleGoNextStep) handleGoNextStep();
      // redirect to success
    } catch (e) {
      // TODO: improve error handling here
      // eslint-disable-next-line no-console
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <VerticalSpace>
      <CardHeader
        title="Acknowledgements"
        icon={<CardAvatar icon={ReadFilled} />}
        onRequestStepBack={handleGoBackStep}
      />

      <Form
        name="onboardingTermsOfServiceForm"
        layout="vertical"
        onFinish={onSubmit}
      >
        <Form.Item
          name="agreeTerms"
          valuePropName="checked"
          rules={[
            {
              required: true,
              validator: (_, value) =>
                value
                  ? Promise.resolve()
                  : Promise.reject(new Error('Must agree to terms of service')),
            },
          ]}
        >
          <Checkbox disabled={loading}>
            I have read the{' '}
            <a
              href="https://www.brokerbay.com/terms-of-service"
              rel="noopener noreferrer"
              target="_blank"
            >
              Terms of Service
            </a>{' '}
            and agree to its terms.
          </Checkbox>
        </Form.Item>

        <Form.Item
          name="agreeEULA"
          valuePropName="checked"
          rules={[
            {
              required: true,
              validator: (_, value) =>
                value
                  ? Promise.resolve()
                  : Promise.reject(new Error('Must agree to EULA')),
            },
          ]}
        >
          <Checkbox disabled={loading}>
            I have read the{' '}
            <a
              href="https://buildings.honeywell.com/us/en/brands/our-brands/supra-systems/legal/end-user-license-agreement"
              rel="noopener noreferrer"
              target="_blank"
            >
              EULA
            </a>{' '}
            and agree to its terms.
          </Checkbox>
        </Form.Item>

        <Form.Item
          name="agreePrivacy"
          valuePropName="checked"
          rules={[
            {
              required: true,
              validator: (_, value) =>
                value
                  ? Promise.resolve()
                  : Promise.reject(new Error('Must agree to Privacy Notice')),
            },
          ]}
        >
          <Checkbox disabled={loading}>
            I have read the{' '}
            <a
              href="https://www.honeywell.com/us/en/privacy-statement"
              rel="noopener noreferrer"
              target="_blank"
            >
              Privacy Notice
            </a>{' '}
            and agree to its terms.
          </Checkbox>
        </Form.Item>

        <Button
          type="primary"
          block
          htmlType="submit"
          disabled={loading}
          loading={loading}
        >
          Create Account
        </Button>
      </Form>
      <CardProgress percent={(4 / 5) * 100} />
    </VerticalSpace>
  );
};
